import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import { resetUser } from "./../redux/actions/user";
import { fetchMachine } from "./../logic/network/fetchMachine";
import { getRefreshToken } from "./../logic/data/localStorage";

export let Logout = ({ dispatch }) => {
	const [done, setDone] = useState(false);

	useEffect(() => {
		const refreshToken = getRefreshToken();

		const finish = () => {
			dispatch(resetUser());
			setDone(true);
		};

		// best-effort logout — fetchMachine handles the access-token refresh/retry
		// internally; if the refresh token itself is dead it throws us out anyway.
		if (!refreshToken) {
			finish();
			return;
		}
		fetchMachine.logout(refreshToken).then(finish).catch(finish);
	}, [dispatch]);

	if (done) {
		return <Redirect to='/login' />;
	}

	return (
		<div className='container md-5 p-5'>
			<h5 className='w-100 text-center'>Logging out.....</h5>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {};
};

Logout = connect(mapStateToProps, null)(Logout);

export default Logout;
